import { render, staticRenderFns } from "./Ferienwohnung.vue?vue&type=template&id=0a277c3c&scoped=true&"
import script from "./Ferienwohnung.vue?vue&type=script&lang=js&"
export * from "./Ferienwohnung.vue?vue&type=script&lang=js&"
import style0 from "./Ferienwohnung.vue?vue&type=style&index=0&id=0a277c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a277c3c",
  null
  
)

export default component.exports